module.exports = __webpack_public_path__ + "static/sridhar-544ced4c65ca24eb107162b4e93982f0.png";